import { HashtagOutputSchema } from "src/features/Hashtags/models";
import { z } from "zod";

const required_error = "This field is required";

// Image Carousel Banner
export const ImageCarouselBannerInputSchema = z.object({
	template: z.literal("fullImageBanner"),

	bannerType: z.enum(["internal", "sponsored"]).default("internal").nullable(),

	imageUuid: z.string({ required_error }).uuid().nullable(),

	headingText: z.string().nullish(),

	subheadingText: z.string().nullish(),

	name: z.string().min(1, "This field is required").nullable(),

	linkType: z.enum(["WEB", "FEED"]).nullish(),

	webLink: z.string().nullish(),

	feed: z.string().uuid().nullish()
});

export const ImageCarouselBannerOutputSchema = z.object({
	id: z.number(),

	template: z.literal("fullImageBanner"),

	bannerType: z.enum(["internal", "sponsored"]).nullable(),

	imageUuid: z.string().uuid().nullable(),

	headingText: z.string().nullish(),

	subheadingText: z.string().nullish(),

	name: z.string().nullable(),

	linkType: z.enum(["WEB", "FEED"]).nullish(),

	webLink: z.string().nullish(),

	feed: HashtagOutputSchema.nullable(),

	activeDays: z.number(),

	createdBy: z
		.object({
			id: z.number(),

			firstName: z.string(),

			lastName: z.string()
		})
		.nullable(),

	updatedAt: z.coerce.date(),

	createdAt: z.coerce.date()
});

export type ImageCarouselBannerInput = z.infer<
	typeof ImageCarouselBannerInputSchema
>;

export type ImageCarouselBannerModel = z.infer<
	typeof ImageCarouselBannerOutputSchema
>;
